const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;

async function getUploadUrl(type) {
  const res = await fetch(
    `${SUPABASE_URL}/functions/v1/cf-upload-url?type=${type}`,
    {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${SUPABASE_ANON_KEY}`,
        'Content-Type': 'application/json',
      },
    }
  );
  if (!res.ok) throw new Error(`Failed to get ${type} upload URL`);
  return res.json();
}

export async function uploadImageToCloudflare(file) {
  const { uploadURL } = await getUploadUrl('image');

  const body = new FormData();
  body.append('file', file);

  const res = await fetch(uploadURL, { method: 'POST', body });
  if (!res.ok) throw new Error('Image upload to Cloudflare failed');

  const json = await res.json();
  const deliveryUrl = json?.result?.variants?.[0];
  if (!deliveryUrl) throw new Error('Cloudflare did not return an image URL');

  return deliveryUrl;
}

export function uploadVideoToCloudflare(file, onProgress) {
  return getUploadUrl('video').then(({ uploadURL, uid }) => {
    return new Promise((resolve, reject) => {
      const formData = new FormData();
      formData.append('file', file, file.name);

      const xhr = new XMLHttpRequest();

      xhr.upload.addEventListener('progress', (e) => {
        if (e.lengthComputable && onProgress) {
          onProgress(Math.round((e.loaded / e.total) * 100));
        }
      });

      xhr.addEventListener('load', () => {
        if (xhr.status >= 200 && xhr.status < 300) {
          resolve({ uid, embedUrl: `https://iframe.cloudflarestream.com/${uid}` });
        } else {
          reject(new Error(`Video upload failed (${xhr.status}): ${xhr.responseText}`));
        }
      });

      xhr.addEventListener('error', () => reject(new Error('Video upload failed (network error)')));
      xhr.addEventListener('abort', () => reject(new Error('Video upload was cancelled')));

      xhr.open('POST', uploadURL);
      xhr.send(formData);
    });
  });
}

export function isCloudflareStreamUrl(url) {
  return typeof url === 'string' && url.includes('cloudflarestream.com');
}
